import { cyan, purple, brown } from "@mui/material/colors";
import { TransactionSource } from "./enums";

export const TRANSACTION_SOURCE_META: Record<
  TransactionSource,
  {
    label: string;
    backgroundColor: string;
    color: string;
  }
> = {
  [TransactionSource.ERP]: {
    label: "ERP",
    backgroundColor: cyan[100],
    color: cyan[600],
  },
  [TransactionSource.LK]: {
    label: "ЛК",
    backgroundColor: purple[100],
    color: purple[600],
  },
  [TransactionSource.LKP]: {
    label: "ЛКП",
    backgroundColor: brown[100],
    color: brown[600],
  },
};
